import { render, staticRenderFns } from "./CaseCloseForm.vue?vue&type=template&id=76b74c2c"
import script from "./CaseCloseForm.vue?vue&type=script&lang=js"
export * from "./CaseCloseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports